export const StoreButtons = ({ dark = false }) => (
  <div className="flex flex-wrap items-center gap-3">
    <span
      data-testid="download-coming-soon"
      className={`inline-flex rounded-md border px-4 py-2.5 text-sm font-semibold ${
        dark ? "border-white/40 text-white" : "border-gray-300 text-gray-900"
      }`}
    >
      Coming soon
    </span>
  </div>
);
